import { APP_CONFIG } from '../../config';
import { get } from '../request';
import type { Entitlement } from '../../@types/entitlement';

export const getEntitlements = async (): Promise<Entitlement[]> =>
  await get(`${APP_CONFIG.entitlementApiUrl}/active-entitlements/my`);
